<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter105">
<p class="centerImage"><img alt="images" id="img15" src="images/img15.jpg"/></p>
<p class="para"><span class="character-style11">Leutnant Norbert Hannig volunteered to join JG54 ‘Green Hearts’ on the Eastern Front, where he flew the Bf 109 for a short while before converting to the FW 190. <em class="italic">Hannig</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter105.vue?3a587960